import OrderInformation from './OrderInformation';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import isEmpty from 'lodash/isEmpty';
import withGlobalContent from '../../../hocs/withGlobalContent';
import arrayToSentence from 'src/common/utils/array-to-sentence';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

const enhance = compose(
  withGlobalContent,
  withProps(({ globalContent: { orders }, items }) => {
    let label = orders.orderInfoLabel || `%{order_number}`;

    const characterNames = items.reduce((result, { customisation: { characters, name } }) => {
      if (characters) {
        characters.map(({ name: characterName }) => {
          result.push(characterName);
        });
      }
      if (name) {
        result.push(name);
      }
      return result;
    }, []);

    if (isEmpty(characterNames)) {
      return {
        label
      };
    }
    // An order with more than 3 names should display the first 2 name
    // + text reading `+ n more` where n is the number of names
    // within the order minus 2
    const remainingNames = characterNames.length > 3 && characterNames.length - 2;
    const namesConjunction = remainingNames ? '' : null;
    const characters = characterNames.reduce((result, name, idx) => {
      if (remainingNames) {
        if (result.length === 3) {
          return result;
        }
        if (idx === 2) {
          const moreItemsLabel = replaceTextWithValues(orders.moreItemsLabel, { remaining_items: remainingNames });
          result.push(`**${moreItemsLabel}**`);
          return result;
        }
      }
      result.push(`**${name}**`);
      return result;
    }, []);

    return {
      label: orders.orderInfoAdventurersLabel || label,
      characters: arrayToSentence(characters, { conjunction: namesConjunction }),
    };
  }),
);

export default enhance(OrderInformation);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderInformation/index.js